// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__s4iUx","isLink":"Tag_isLink__FvlPM"};